/**
 * auth.service — llamadas de autenticación al API.
 */
import { httpPost } from "@/shared/lib/http-client.js";

export type Rol = "admin" | "technician";

export interface AuthUser {
  id: string;
  nombre: string;
  email: string;
  rol: Rol;
}

export interface LoginResponse {
  token: string;
  refreshToken: string;
  user: AuthUser;
}

export function login(email: string, password: string): Promise<LoginResponse> {
  return httpPost<LoginResponse>("/auth/login", { email, password });
}

/**
 * Renueva el access token a partir del refresh token.
 *
 * IMPORTANTE: NO debe pasar por el interceptor de 401/refresh del http-client
 * (evita recursión). httpPost exime explícitamente la ruta /auth/refresh del
 * loop, así que un 401 acá es un fallo duro (refresh inválido/expirado).
 */
export function refresh(refreshToken: string): Promise<LoginResponse> {
  return httpPost<LoginResponse>("/auth/refresh", { refreshToken });
}
